import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { UserType } from '../lib/auth/types';
import { Loader2 } from '@pagespeedify/ui'; // Import Loader2

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: UserType[];
  isAdminRequired?: boolean;
}

export default function ProtectedRoute({ children, allowedRoles, isAdminRequired }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, userType, isAdmin } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4 bg-background text-foreground"> {/* Use theme background/text */}
        <Loader2 className="h-12 w-12 animate-spin text-primary" />
      </div>
    );
  }

  // Redirect if not authenticated (after loading is finished)
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check admin requirement
  if (isAdminRequired && !isAdmin) {
    return <Navigate to="/unauthorized" replace />; // Or redirect to a relevant dashboard/page
  }

  // Check role requirement
  if (allowedRoles && (!userType || !allowedRoles.includes(userType))) {
    return <Navigate to="/unauthorized" replace />; // Or redirect to a relevant dashboard/page
  }

  // If authenticated and authorized, render the children (Layout + Outlet)
  return <>{children}</>;
}